import countriesData from '../data/countries.json';

export const getCountryTranslation = (countryName, currentLanguage) => {
  if (!countryName) return countryName;

  const languageMap = {
    'ar': 'ar',
    'fr': 'fr',
    'en': 'en'
  };

  const targetLanguage = languageMap[currentLanguage] || 'ar';
  const translationKey = countryName.trim();

  const newTranslations = JSON.parse(localStorage.getItem('countryTranslations') || '{}');

  if (newTranslations[translationKey]) {
    return newTranslations[translationKey][targetLanguage] || countryName;
  }

  const staticTranslation = countriesData.countries[translationKey];
  if (staticTranslation) {
    return staticTranslation[targetLanguage] || countryName;
  }

  return countryName;
};

export const addCountryTranslation = (countryName, translations) => {
  const newTranslations = JSON.parse(localStorage.getItem('countryTranslations') || '{}');
  const translationKey = countryName.trim();

  newTranslations[translationKey] = {
    ar: translations.ar || countryName,
    fr: translations.fr || countryName,
    en: translations.en || countryName
  };

  localStorage.setItem('countryTranslations', JSON.stringify(newTranslations));

  const combinedData = { ...countriesData.countries, ...newTranslations };
  const jsonString = JSON.stringify({ countries: combinedData }, null, 2);

  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'countries.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return { success: true, message: 'Country translations saved to localStorage and exported.' };
};

export const reloadTranslations = () => {
  // This function would typically re-fetch or re-load the static data if it were dynamic.
  // For now, it just returns the current static data.
  return countriesData;
};

export const validateTranslationsFile = (file) => {
  // Placeholder for actual file validation logic
  return { success: true, message: 'File validated successfully.' };
};

export const saveTranslationsToFile = () => {
  const newTranslations = JSON.parse(localStorage.getItem('countryTranslations') || '{}');
  const combinedData = { ...countriesData.countries, ...newTranslations };
  const jsonString = JSON.stringify({ countries: combinedData }, null, 2);

  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'countries.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  return { success: true, message: 'Country translations exported to countries.json.' };
};
